import React, { Component } from 'react'
import Button from "reactstrap/es/Button"
import { getLocalData } from "../../../services/StorageServices";
import { parseJwt } from "../../../share/parseToken";
import BulkHoldShipModal from './BulkHoldShipModal';

class BulkHoldShip extends Component {
    state = {
        isOpen: false,
    }

    _handleToggleModal = () => {
        const { resetBulkAll, reloadItems, closeMenu } = this.props
        const { isOpen } = this.state

        this.setState({
            isOpen: !isOpen
        })

        if (isOpen) {
            resetBulkAll()
            closeMenu()
            reloadItems()
        }
    }

    render() {
        const { items = [], selectedItems = [] } = { ...this.props }
        const listItems = items.filter(item => selectedItems.includes(item._id))
        const { isOpen } = this.state
        const token = getLocalData('accessToken')
        const roles = token !== '' && parseJwt(token).roles ? parseJwt(token).roles : []
        const rolesArr = roles.map(role => {
            return role.name
        })

        const listItemsDisable = listItems.filter(itemD => (!['pending', 'in_production', 'on-hold', 'false_design'].includes(itemD.production_status)) || itemD.tags.includes('hold-ship'))

        return (
            <div>
                <Button color="link" onClick={this._handleToggleModal} disabled={listItemsDisable.length > 0 ? true : false} className="mr-1">Hold ship</Button>
                {isOpen && (
                    <BulkHoldShipModal
                        {...this.props}
                        isOpen={isOpen}
                        roles={rolesArr}
                        handleToggleModal={this._handleToggleModal}
                    />
                )}
            </div>
        );
    }

}

export default BulkHoldShip